<template>
    <div class="fs5-request-payments" id="fs5-request-payments">
        <div class="get-paid-title-card">
            <div class="get-paid-title" v-html="view.translations['fs5_get_paid_title']"></div>
        </div>
        <div class="get-paid-info" data-toggle="tooltip" data-placement="bottom"
                data-html="true" :title="view.translations.label_prediction_gains_page">
            <img :src="'/internacional/public/office5/img/franchise_dashboard/svg/info.svg'">
        </div>
        <div class="get-paid-body">
            <fs5-button
                v-for="(value, index) in buttonAvailable"
                :key="index"
                :label="value.description"
                :text-transform-type="'capitalize'"
                @clicked="open(value.btn)"
                :disabled="value.status"
            ></fs5-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'fs5-request-payments',
        props: ['view'],
        computed: {
            buttonAvailable () {
                let buttons = []
                var i = 0
                if (this.view.get_paid_btns.btn_conditions.showEwallet) {
                    if (!this.view.get_paid_btns.btn_conditions.ipayout_username) 
                    {
                        buttons[i] = {description: this.view.get_paid_btns.btn_translation.label_setup_ewallet, btn: 1, status: false}
                        i++
                    } 
                    else 
                    {
                        buttons[i] = {description: this.view.get_paid_btns.btn_translation.label_access_ewallet, btn: 2, status: false}
                        i++
                    }
                }
                buttons[i] = {description: this.view.get_paid_btns.btn_translation.office2_ganhos_solicitacao_saque, btn: 3, status: this.view.get_paid_btns.btn_conditions.disable_btn_saque}
                i++
                return  buttons
            }
        },
        methods: {
            open(data)
            {
                if(data == 1)
                {
                    $('#setupEwalltet').modal('show');
                }
                else if(data == 2)
                {
                    window.open(this.view.get_paid_btns.btn_conditions.url_access_ewallet);
                }
                else
                {
                    $('#solicitarSaqueModal').modal('show');
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../../../scss/extras/_variables'; // see fonts and colors with prefix $fs5
    .fs5-request-payments {
        font: inherit;
        background-color: $fs5-color3;
        border-radius: 0.8em;
        border: 1px $fs5-color1 solid;
        padding:  1em 4em;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;
        column-gap: 1em;
        justify-content: center;

        .get-paid-title-card{
            display: inline-flex;
            background-color: transparent;

            .get-paid-title {
                font: inherit;
                font-size: 1.6em;
                color: $fs5-color2;
                font-weight: 800;
                text-transform: capitalize;
                margin-right: 0.25em;
            }
        }
        .get-paid-info {
            margin: 1px 0;
            img {
                height: 1.5em;
            }
        }
        .get-paid-body {
            column-gap: 5px;
            display: inline-flex;
            background-color: transparent;
            justify-content: center;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/get_paid/user/request_payments/index.vue